import { createContext, useContext } from "react";

/** Firebase authentication UID, which is distinct from the app's user document ID. */
export const ApiSessionContext = createContext<string | null>(null);
export const useApiSession = () => useContext(ApiSessionContext);
